import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconSheetCollapse16(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.618 2.667c.947 0 1.715.768 1.715 1.715v7.236c0 .947-.768 1.715-1.715 1.715H4.382a1.715 1.715 0 01-1.715-1.715V4.382c0-.947.768-1.715 1.715-1.715h7.236zm.715 1.715a.715.715 0 00-.715-.715H4.382a.715.715 0 00-.715.715v7.236c0 .395.32.715.715.715h7.236c.395 0 .715-.32.715-.715V4.382zM5.056 11.5h.888a.556.556 0 00.556-.556V5.056a.556.556 0 00-.556-.556h-.888a.556.556 0 00-.556.556v5.888c0 .307.249.556.556.556z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.104 6.604a.5.5 0 10-.708-.708L7.648 7.645a.498.498 0 000 .71l1.748 1.749a.5.5 0 00.707-.708L9.207 8.5h2.043a.5.5 0 000-1H9.207l.896-.896z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconSheetCollapse16);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;